// removed by extract-text-webpack-plugin
module.exports = {"container":"container___CDT0P","wrapper":"wrapper___1np3-","logo":"logo___3q60X","info":"info___3vV2c","modal":"modal___1shcX","header":"header___2PA04","body":"body___2lhLH","close":"close___1Pvbs","overlay":"overlay___2VIb4","hidden":"hidden___jxQzh","form":"form___1EWVY","gapBottom45":"gapBottom45___NKeB4","gapTop20":"gapTop20___1AuH9","content":"content___1XbFm","package":"package___3yBWe","unit":"unit___1z9JB","label":"label___pmfON","intro":"intro___1xGHx","pinfo":"pinfo___2wBFe"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Page3.scss
// module id = 51
// module chunks = 0